module.exports = __webpack_public_path__ + "images/CC_Multi Choice Media Placeholders_2.svg";